import { render, staticRenderFns } from "./print-handover-customer-report.vue?vue&type=template&id=082ffb52&scoped=true&"
import script from "./print-handover-customer-report.vue?vue&type=script&lang=ts&"
export * from "./print-handover-customer-report.vue?vue&type=script&lang=ts&"
import style0 from "./print-handover-customer-report.vue?vue&type=style&index=0&id=082ffb52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082ffb52",
  null
  
)

export default component.exports